import { Action } from '@ngrx/store';

export enum ErrorActionTypes {
  AuthorisationErrorOccurred = '[Errors] Authorisation Error Occurred',
  NotFoundErrorOccurred = '[Errors] Not Found Error Occurred',
  ParamsNotValidErrorOccurred = '[Errors] Params Not Valid Error Occurred',
  HttpExceptionErrorOccurred = '[Errors] HTTP Exception Error Occurred',
  SessionExpiredErrorOccurred = '[Errors] Session Expired Error Occurred',
  UnhandledExceptionErrorOccurred = '[Errors] Unhandled Exception Error Occurred',
}

export class AuthorisationErrorOccurred implements Action {
  readonly type = ErrorActionTypes.AuthorisationErrorOccurred;
}

export class NotFoundErrorOccurred implements Action {
  readonly type = ErrorActionTypes.NotFoundErrorOccurred;
}

export class ParamsNotValidErrorOccurred implements Action {
  readonly type = ErrorActionTypes.ParamsNotValidErrorOccurred;
  constructor(public payload: { message: string }) {}
}

export class HttpExceptionErrorOccurred implements Action {
  readonly type = ErrorActionTypes.HttpExceptionErrorOccurred;
  constructor(public payload: { message: string }) {}
}

export class SessionExpiredErrorOccurred implements Action {
  readonly type = ErrorActionTypes.SessionExpiredErrorOccurred;
}

export class UnhandledExceptionErrorOccurred implements Action {
  readonly type = ErrorActionTypes.UnhandledExceptionErrorOccurred;
  constructor(public payload: { error: Error; stack?: string }) {}
}

export type ErrorActions =
  | AuthorisationErrorOccurred
  | NotFoundErrorOccurred
  | ParamsNotValidErrorOccurred
  | HttpExceptionErrorOccurred
  | SessionExpiredErrorOccurred
  | UnhandledExceptionErrorOccurred;
